import React, { useState } from "react";
import styles from "../styles/Perfil.module.css";
import { handleChangePassword } from "../handlers/usuarios";

const Perfil = () => {
  const username = localStorage.getItem("username");
  const full_name = localStorage.getItem("full_name");
  const mail = localStorage.getItem("mail");
  const profile_id = localStorage.getItem("profile_id");

  // Estados para el formulario de cambio de contraseña
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  return (
    <div className={styles.perfilContainer}>
      <h3 className={styles.tituloPerfil}>👤 Información de perfil</h3>
      <table className={styles.table}>
        <tbody>
          <tr>
            <td className={styles.label}>Usuario:</td>
            <td>{username}</td>
          </tr>
          <tr>
            <td className={styles.label}>Nombre completo:</td>
            <td>{full_name}</td>
          </tr>
          <tr>
            <td className={styles.label}>Correo:</td>
            <td>{mail}</td>
          </tr>
          <tr>
            <td className={styles.label}>Perfil ID:</td>
            <td>{profile_id}</td>
          </tr>
        </tbody>
      </table>

      <div className={styles.passwordSection}>
        <h4 className={styles.passwordTitle}>Modificar contraseña</h4>
        <form
          onSubmit={(e) =>
            handleChangePassword({
              e,
              username,
              currentPassword,
              newPassword,
              confirmPassword,
              setMessage,
              setCurrentPassword,
              setNewPassword,
              setConfirmPassword,
            })
          }
          className={styles.passwordForm}
        >
          <input
            type="password"
            placeholder="Contraseña Actual"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className={styles.input}
          />
          <input
            type="password"
            placeholder="Nueva Contraseña"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className={styles.input}
          />
          <input
            type="password"
            placeholder="Confirmar Contraseña"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={styles.input}
          />
          <button type="submit" className={styles.button}>
            Cambiar contraseña
          </button>
        </form>
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};

export default Perfil;